import "./main.css";
import Leftsignupform from "./LeftSignupForm/Leftsignupform";
import Signupimage from "./SignupImage/Signupimage";

function Main() {
    return (
        <div>
                <div className="Main-container">
                    <Leftsignupform></Leftsignupform>
                    <Signupimage></Signupimage>
                </div>  
        </div>
    );
}

export default Main;